<template>
    <main class="news all_posts">

        <article class="news news2">
            <ArticleLogo :article="article" />
        </article>
        <LeagueLogo logo="ucl" />
        <div :class="$route.path.includes('/ucl') && 'sub_container_small'" class="sub_container_b">
            <NewsSubMenu name="Info" route="uclinfo" />
            <NewsSubMenu name="tables" route="uclstages" />
            <NewsSubMenu name="Matchday" route="uclmatchday" />
            <NewsSubMenu name="Goal-Scorers" route="uclgs" />
        </div>
        <ul class="league_info fixtures ">

            <div class="league_goalscorers">
                <UclScorers v-if="activeSubMenu == 'table'" :limit="25" :currentYear="currentYear" key="currentYear"
                    :fullScreen="fullScreen" />
            </div>
        </ul>

    </main>
</template>

<script>
import NewsSubMenu from '@/components/team/NewsSubMenu.vue'
import ArticleLogo from '../components/ArticleLogo.vue'
import UclScorers from '@/components/team/UclScorers.vue'
import LeagueLogo from '@/components/LeagueLogo.vue'

export default {
    name: 'SerieAgs',
    components: { ArticleLogo, NewsSubMenu, UclScorers, LeagueLogo },
    emits: ['news_direction'],
    data() {
        return {
            title: '2024 Top Goalscorers',
            fullScreen: true,
            article: 'News',
            limit: undefined,
            activeMenu: 'serie A',
            activeSubMenu: 'table',
            currentYear: 'default',
            customStyle: {
                width: '75px',
                height: '75px'
            }
        }
    },
    mounted() {
        document.title = 'Ucl top Goal Scorers / Rossoneries';

    }

}
</script>

<style >
.league_goalscorers {
    width: 100%;
}
</style>